import { Button } from '@lms/ui/button';
import { LoaderCircle, PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { createCourse } from '@/features/courses/courses-api';

// Ports app/[brand]/admin/courses/_components/add-course-card.tsx. The Next
// action created the course and `redirect`ed to its editor; here we await the
// new course and navigate with react-router.
export function AddCourseButton({
  locationId,
  slug,
}: {
  locationId: number;
  slug: string;
}) {
  const [loading, setLoading] = useState(false);
  const t = useTranslations('addcourse');
  const navigate = useNavigate();

  const handleClick = async () => {
    setLoading(true);
    try {
      const course = await createCourse(locationId);
      navigate(`/${slug}/admin/courses/${course.id}`);
    } catch {
      setLoading(false);
    }
  };

  return (
    <Button onClick={handleClick} disabled={loading}>
      {loading ? (
        <LoaderCircle className="h-10 w-10 animate-spin" />
      ) : (
        <PlusIcon className="h-10 w-10" />
      )}
      {t('add_course')}
    </Button>
  );
}
